import styled from '@emotion/styled';

export const Container = styled.div`
    margin: 12px;
`;
